export default __webpack_public_path__ + "static/tlo_v1-35f9dbf6a0ab8e2e656fb6d4e53bb644.jpg";